import * as r from "react";
import o from "../lib/IconBase.es.js";
import m from "../defs/CarBattery.es.js";
const t = r.forwardRef((a, e) => /* @__PURE__ */ r.createElement(o, { ref: e, ...a, weights: m }));
t.displayName = "CarBatteryIcon";
const n = t;
export {
  n as CarBattery,
  t as CarBatteryIcon
};
